import { sendDataLayer } from "./ecommerce";

declare let dataObject: any;

export const sendBreadCrumbImpression = () =>
{    
    const $breadcrumbHolder = $(".j-breadcrumbs div a");
    if ($breadcrumbHolder.length > 0) 
    {
        const breadcrumbs: Record<string, string> = {};
        let i = 1;

        $breadcrumbHolder.each(function () 
        {
            const breadcrumbHref = $(this).attr("href");
            if (breadcrumbHref !== undefined && breadcrumbHref != null && breadcrumbHref !== "") 
            {
                // Create array of breadcrumb parts, filtering out empty values
                const breadcrumbArray = breadcrumbHref.split("/").filter(Boolean);
                // Get the last item in the url
                let lastItem = breadcrumbArray.pop();

                // Add fallback for Home
                if (lastItem === undefined || lastItem == null)
                    lastItem = "/";

                // Ensure suffix
                if (!lastItem.endsWith("/"))
                    lastItem += "/";

                // Ensure prefix
                if (!lastItem.startsWith("/"))
                    lastItem = "/" + lastItem;

                breadcrumbs["Item" + i] = lastItem;
                i++;
            }
        });

        const $currentKeyword = $("input[name='current_keyword']");
        const $currentKeywordAlt = $("[itemprop='current_keyword']");
        const $currentSuggestionKeyword = $("input[name='suggestion_keyword']");
        const $currentCategory = $("input[name='current_category']");

        const keywordValue = $currentKeyword.val() as string;
        const altContentValue = $currentKeywordAlt.attr("content");
        const searchInputValue = $(".searchform.search-holder .search-input").val() as string;

        // For keywords on category/search/brand pages
        if ($currentKeyword.length > 0 && keywordValue !== undefined && keywordValue !== "")
            breadcrumbs["keyword"] = keywordValue;
        // For keywords on productdetail page
        else if ($currentKeywordAlt.length > 0 && altContentValue !== undefined && altContentValue !== "")
            breadcrumbs["keyword"] = altContentValue;
        else if (typeof dataObject !== "undefined" && dataObject["keyword"] !== undefined)
            breadcrumbs["keyword"] = dataObject["keyword"];
        else if (origin === "search" && $(".searchform.search-holder .search-input").length > 0 && searchInputValue.length > 0)
            breadcrumbs["keyword"] = searchInputValue;
        else
            breadcrumbs["keyword"] = "";

        const suggestionValue = $currentSuggestionKeyword.val() as string;
        if ($currentSuggestionKeyword.length > 0 && suggestionValue !== undefined && suggestionValue !== "")
            breadcrumbs["suggestion"] = suggestionValue;
        else
            breadcrumbs["suggestion"] = "";

        const categoryValue = $currentCategory.val() as string;
        if ($currentCategory.length > 0 && categoryValue !== undefined && categoryValue !== "")
            breadcrumbs["ca"] = categoryValue;
        else
            breadcrumbs["ca"] = "";

        breadcrumbs["tms"] = "gtm-custom";

        if (breadcrumbs["keyword"] !== undefined && breadcrumbs["keyword"] !== "")
            breadcrumbs["event"] = "zoeken";

        sendDataLayer(breadcrumbs);
    }
}

export const getBreadCrumbImpression = (): Record<string, string> => 
{
    const $breadcrumbHolder = $(".j-breadcrumbs div a");

    const breadcrumbs: Record<string, string> = {
        "item1": "Home",
        "item2": "",
        "item3": "",
        "item4": "",
        "item5": "",
        "item6": ""
    };

    if ($breadcrumbHolder.length > 0) 
    {
        let i = 1;
        $breadcrumbHolder.each(function (this: HTMLElement) 
        {
            const breadcrumbTitle = $(this).attr("title");
            if (breadcrumbTitle !== undefined && breadcrumbTitle != null && breadcrumbTitle !== "") 
            {
                breadcrumbs["item" + i] = breadcrumbTitle;
                i++;
            }
        });
    }

    return breadcrumbs;
};

if (!(window as any).sendBreadCrumbImpression)
{
    (window as any).sendBreadCrumbImpression = sendBreadCrumbImpression;
    document.addEventListener("DOMContentLoaded", () =>
    {
        sendBreadCrumbImpression();
    });
}